// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__1cch4","pulse":"Skeleton_pulse__yl1FX"};